import { ServiceClient } from 'src/utils'
import { Empresa, GrupoResumo, OrdemGrupos, Simulacao, Situacao, Sugestao } from './GrupoManual.scopes'

const serviceClient = ServiceClient.singleton()

const BASE_URL = '/api/grupos-manuais'

export class GrupoManualService {
    static #INSTANCE = new GrupoManualService()
    static readonly singleton = () => GrupoManualService.#INSTANCE

    async pesquisar(
        filtro: string,
        ordem: OrdemGrupos,
        offset: number,
        limit: number
    ): Promise<{ total: number; itens: GrupoResumo[] }> {
        const params = new URLSearchParams({ ordem, offset: `${offset}`, limit: `${limit}` })
        if (filtro) params.set('q', filtro)
        return serviceClient.authGet(`${BASE_URL}?${params.toString()}`)
    }

    async conferirEmpresa(cnpj: string): Promise<Empresa> {
        return serviceClient.authGet<Empresa>(`${BASE_URL}/empresa/${cnpj}`)
    }

    async sugerir(texto: string): Promise<Sugestao[]> {
        return serviceClient.authGet<Sugestao[]>(`${BASE_URL}/empresas?q=${encodeURIComponent(texto)}`)
    }

    async simular(cnpj: string, outroCnpj: string): Promise<Simulacao> {
        return serviceClient.authPost<Simulacao>(`${BASE_URL}/simular`, { cnpj, outroCnpj })
    }

    async unir(cnpj: string, outroCnpj: string, motivo: string): Promise<{ grupoId: number; grupoAbsorvido: number }> {
        return serviceClient.authPost(`${BASE_URL}/unir`, { cnpj, outroCnpj, motivo })
    }

    async situacao(cnpj: string): Promise<Situacao> {
        return serviceClient.authGet<Situacao>(`${BASE_URL}/empresa/${cnpj}/situacao`)
    }

    async ligar(
        cnpj: string,
        outroCnpj: string,
        motivo: string
    ): Promise<{ resultado: 'criado' | 'incluida'; grupoId: number }> {
        return serviceClient.authPost(`${BASE_URL}/ligar`, { cnpj, outroCnpj, motivo })
    }

    async retirar(grupoId: number, cnpj: string, motivo: string): Promise<void> {
        await serviceClient.authDelete(`${BASE_URL}/${grupoId}/membros/${cnpj}`, { motivo })
    }
}

export default GrupoManualService.singleton()
